const getRelatedShowPageData = content => {
  const showPageUrl = content.showPage?.entity?.url?.path;
  if (showPageUrl) {
    return {
      id: content.showPage.entity.id,
      name: content.showPage.entity.title,
      url: showPageUrl
    };
  }
  return null;
};

module.exports = {
  getRelatedShowPageData
};
